import React from 'react';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { QFormControl, QSelect, QSelectItem, QSelectPlaceholder, QText } from '@qualio/ui-components';

type TemplateAccountFilterProps = {
  accountOptions: QSelectItem<string, string>[];
};

export const TemplateAccountFilter: React.FC<TemplateAccountFilterProps> = ({ accountOptions }) => {
  const { t } = useTranslation();

  return (
    <Controller
      name="account"
      render={({ field: { onChange, value } }) => (
        <QFormControl label={t('template.list.filters.account.label')}>
          <QSelect
            options={accountOptions}
            value={value ?? null}
            onChange={(item: QSelectItem | null) => onChange(item?.value ?? null)}
            isClearable
            clearInputOnSelect={value == null}
            data-cy="template-account-filter-v2"
            aria-label={t('template.list.filters.account.ariaLabel')}
          >
            <QSelectPlaceholder>
              <QText>{t('template.list.filters.account.placeholder')}</QText>
            </QSelectPlaceholder>
          </QSelect>
        </QFormControl>
      )}
    />
  );
};
